var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.75 10.5508C5.75 7.89937 7.89937 5.75 10.5507 5.75C13.2021 5.75 15.3515 7.89937 15.3515 10.5508C15.3515 11.8543 14.832 13.0364 13.9887 13.9015C13.9734 13.915 13.9584 13.9292 13.9438 13.9438C13.9291 13.9585 13.915 13.9735 13.9015 13.9888C13.0364 14.832 11.8542 15.3515 10.5507 15.3515C7.89937 15.3515 5.75 13.2022 5.75 10.5508ZM14.6005 16.0148C13.4692 16.8547 12.068 17.3515 10.5507 17.3515C6.79479 17.3515 3.75 14.3067 3.75 10.5508C3.75 6.79481 6.79479 3.75 10.5507 3.75C14.3067 3.75 17.3515 6.79481 17.3515 10.5508C17.3515 12.068 16.8546 13.4692 16.0147 14.6006L19.958 18.5438C20.3485 18.9343 20.3485 19.5675 19.958 19.958C19.5674 20.3486 18.9343 20.3486 18.5438 19.958L14.6005 16.0148Z",
    fill: "#F7E4FB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.1d71e0201ab989caebcd90839748ba25.svg";
export { ForwardRef as ReactComponent };